import { xor } from "lodash"

export class SumupUnitResult {
  sumup_unit_id: number
  student_no_character: string
  name: string
  unit_type: number
  score: number
  allot: number
  total_rank: number
  total_std_score: number
  total_avg_score: number
  total_max_score: number
  total_min_score: number
  total_examinee_count: number
  gender_rank: number
  gender_std_score: number
  gender_avg_score: number
  gender_max_score: number
  gender_min_score: number
  gender_examinee_count: number

  constructor(x: any){
    this.sumup_unit_id = x.sumup_unit_id;
    this.student_no_character = x.student_no_character;
    this.name = x.name;
    this.unit_type = x.unit_type;
    this.score = x.score
    this.allot = x.allot;
    this.total_rank = x.total_rank;
    this.total_std_score = x.total_std_score?.toFixed(1);
    this.total_avg_score = x.total_avg_score?.toFixed(1);
    this.total_max_score = x.total_max_score;
    this.total_min_score = x.total_min_score;
    this.total_examinee_count = x.total_examinee_count;
    this.gender_rank = x.gender_rank;
    this.gender_std_score = x.gender_std_score?.toFixed(1);
    this.gender_avg_score = x.gender_avg_score?.toFixed(1);
    this.gender_max_score = x.gender_max_score;
    this.gender_min_score = x.gender_min_score;
    this.gender_examinee_count = x.gender_examinee_count;
  }
}

export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
  }
}

export class AssessmentResult {
  name: string
  score_type: number
  assessment_score_results: AssessmentScoreResult[]


  constructor(x: any){
    this.name = x.name;
    this.score_type = x.score_type;
    this.assessment_score_results = x.assessment_score_results.map((y: any) => new AssessmentScoreResult(y))
  }
}

export class AssessmentScoreResult {
  id: number
  base_assessment_id: number
  score_from: number
  score_to: number
  comment: string
  is_exists_assessment_examinee: boolean

  constructor(x: any){
    this.id = x.id;
    this.base_assessment_id = x.base_assessment_id;
    this.score_from = x.score_from;
    this.score_to = x.score_to;
    this.comment = x.comment;
    this.is_exists_assessment_examinee = x.is_exists_assessment_examinee;
  }
}

export class AssessmentExaminee {
  assessment_score_id: number
  constructor(x: any){
    this.assessment_score_id = x.assessment_score_id;
  }
}

export class SumupBunpu {
  sumup_unit_id: number
  score_from: number = null
  score_to: number = null
  examinee_count: number = null
  percent: number = null
  graph_percent: number = null

  constructor(sumupBunpu: any){
    if(sumupBunpu){
      this.sumup_unit_id = sumupBunpu.sumup_unit_id;
      this.score_from = sumupBunpu.score_from;
      this.score_to = sumupBunpu.score_to;
      this.examinee_count = sumupBunpu.examinee_count;
      this.percent = sumupBunpu.percent;
      this.graph_percent = sumupBunpu.graph_percent;
    }
  }
}

export class BunpuResult {
  no: number
  sumupBunpus: SumupBunpu[]
  cols: any[] = new Array<any>()
  colKinds: ColKindEnum[] = new Array<ColKindEnum>()

  constructor(sumupBunpus: any, sumupUnitResults: SumupUnitResult[]){
    this.sumupBunpus = sumupBunpus.map((x: any) => new SumupBunpu(x));
    this.sumupBunpus.forEach(x => {
      if(x.score_to){
        this.cols.push(`${x.score_to}点<br>～<br>${x.score_from}点`);
        this.cols.push(`${x.examinee_count}名`);
        const sumupUnitResult = sumupUnitResults.filter(y => x.sumup_unit_id == y.sumup_unit_id)
        const is_exists_examinee = sumupUnitResult.length > 0 && sumupUnitResult[0].score >= x.score_from && sumupUnitResult[0].score <= x.score_to;
        this.cols.push([x.percent.toFixed(0), x.graph_percent.toFixed(0), is_exists_examinee]);
      }else{
        this.cols.push("-");
        this.cols.push("-");
        this.cols.push([0, 0, false]);
      }

      this.colKinds.push(ColKindEnum.ScoreRange);
      this.colKinds.push(ColKindEnum.Count);
      this.colKinds.push(ColKindEnum.ScoreRate);
    })
  }
}

export class SumupUnitAll {
  sumup_unit_id: number
  name: string
  unit_type: number
  bunpu_count: number
  total_examinee_count: number
  man_examinee_count: number
  woman_examinee_count: number
  total_avg_score: number
  man_avg_score: number
  woman_avg_score: number
  total_std_dev: number
  man_std_dev: number
  woman_std_dev: number
  total_min_score: number
  man_min_score: number
  woman_min_score: number
  total_max_score: number
  man_max_score: number
  woman_max_score: number
  allot: number
  result_published: boolean

  constructor(x: any){
    this.sumup_unit_id = x.sumup_unit_id;
    this.name = x.name;
    this.unit_type = x.unit_type;
    this.bunpu_count = x.bunpu_count;
    this.total_examinee_count = x.total_examinee_count;
    this.man_examinee_count = x.man_examinee_count;
    this.woman_examinee_count = x.woman_examinee_count;
    this.total_avg_score = x.total_avg_score.toFixed(1);
    this.man_avg_score = x.man_avg_score.toFixed(1);
    this.woman_avg_score = x.woman_avg_score.toFixed(1);
    this.total_std_dev = x.total_std_dev.toFixed(1);
    this.man_std_dev = x.man_std_dev.toFixed(1);
    this.woman_std_dev = x.woman_std_dev.toFixed(1);
    this.total_min_score = x.total_min_score;
    this.man_min_score = x.man_min_score;
    this.woman_min_score = x.woman_min_score;
    this.total_max_score = x.total_max_score;
    this.man_max_score = x.man_max_score;
    this.woman_max_score = x.woman_max_score;
    this.allot = x.allot;
    this.result_published = x.result_published;
  }
}

export interface PracticeFileUpload {
  id: number
  is_personal: boolean
  title: string
}

export enum ColKindEnum{
  ScoreRange = 1,
  Count = 2,
  ScoreRate = 3
};